import { useState, useEffect } from 'react';
import { getIndustries } from 'wisestep-api';
import { WsSelectObj } from 'wisestep-base';

interface UseIndustriesResult {
  industries: WsSelectObj[] | null;
  loading: boolean;
  error: Error | null;
  refresh: () => void;
}

export const useIndustries = (): UseIndustriesResult => {
  const [industries, setIndustries] = useState<WsSelectObj[] | null>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<Error | null>(null);

  const fetchIndustries = async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await getIndustries();
      if (response?.data) {
        setIndustries(response.data);
      }
    } catch (err) {
      setError(err as Error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchIndustries();
  }, []);

  return { industries, loading, error, refresh: fetchIndustries };
};
